import React, { useState } from 'react'

import { PlusOutlined, UploadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import ContactAddressList from '@shared/contact_addresses/ContactAddressList'
import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import ListPageHeader from '@shared/ListPageHeader'
import Can from '@shared/permissions/Can'

import { contactAddressService } from '@services/operator/contactAddressService'
import { salesChannelService } from '@services/operator/salesChannelService'

const OperatorContactAddressList: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { merchants } = useOperatorData() as { merchants: Array<{ id: string; name: string }> }
  const isStandard = useIsStandard()
  const { addJob } = useOperatorNotification()
  const [importModalVisible, setImportModalVisible] = useState(false)

  return (
    <div>
      <ListPageHeader
        items={['merchants', 'merchants.contact_addresses']}
        actions={
          <>
            <Can requiredPermission="contact_addresses:write">
              <Button icon={<UploadOutlined />} onClick={() => setImportModalVisible(true)}>
                {t('common.button.import')}
              </Button>
            </Can>
            <Can requiredPermission="contact_addresses:write">
              <Button type="primary" icon={<PlusOutlined />} onClick={() => navigate('/contact_addresses/new')}>
                {t('common.button.new')}
              </Button>
            </Can>
          </>
        }
      />
      <ContactAddressList
        service={contactAddressService}
        salesChannelService={salesChannelService}
        role="operator"
        hideMerchantUI={isStandard}
        merchants={merchants}
        addJob={addJob}
        importModalVisible={importModalVisible}
        setImportModalVisible={setImportModalVisible}
      />
    </div>
  )
}

export default OperatorContactAddressList
